// Current versions of the legal documents users must accept.
// Bumping a version forces every user to accept again.
export const LEGAL_VERSIONS = {
  terms: "2026-09-30",
  data_policy: "2026-09-30",
} as const;

export type LegalDocument = keyof typeof LEGAL_VERSIONS;

export const canSubmitConsent = (acceptTerms: boolean, acceptPolicy: boolean) =>
  acceptTerms && acceptPolicy;

export const getMissingConsents = (
  accepted: { document: string; version: string }[]
): LegalDocument[] =>
  (Object.keys(LEGAL_VERSIONS) as LegalDocument[]).filter(
    (doc) => !accepted.some((a) => a.document === doc && a.version === LEGAL_VERSIONS[doc])
  );
